import { render, staticRenderFns } from "./CodesDataTable.vue?vue&type=template&id=e7973f9e"
import script from "./CodesDataTable.vue?vue&type=script&lang=ts"
export * from "./CodesDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports